import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/main-color-schemes/light-blue.style.ts
import { css, unsafeCSS } from "lit";
var themeLightBlue = (targetName = ":root") => css`
    /* @Builder: skip minify */
    ${unsafeCSS(targetName)} {
        --logo-text-color: #1B314F;

        --color-background-bg-active: #ffffff;
        --color-background-bg-body: #eaecf0;
        --color-background-bg-critical: #f048322e;
        --color-background-bg-critical-hover: #f048323d;
        --color-background-bg-disabled: #98a2b3;
        --color-background-bg-info: #2f8af52e;
        --color-background-bg-info-hover: #2f8af53d;
        --color-background-bg-positive: #21c1872e;
        --color-background-bg-positive-hover: #21c1873d;
        --color-background-bg-primary: #ffffff;
        --color-background-bg-secondary: #f2f4f7;
        --color-background-bg-tertiary: #d0d5dd;
        --color-background-bg-warning: #ff9c082e;
        --color-background-bg-warning-hover: #ff9c083d;
        --color-border-border-primary: #667085;
        --color-border-border-secondary: #98a2b3;
        --color-border-border-tertiary: #d0d5dd;
        --color-content-content-disabled: #abb7cc;
        --color-content-content-primary: #101828;
        --color-content-content-primary-inv: #ffffff;
        --color-content-content-secondary: #6b7a93;
        --color-content-content-tertiary: #8f9db5;
        --color-core-black: #101828;
        --color-core-white: #ffffff;
        --color-core-blue-info: #2f8af5;
        --color-core-blue-info-hover: #157cf4;
        --color-core-green-positive: #008a7c;
        --color-core-green-positive-hover: #00786c;
        --color-core-orange-warning: #ff9c08;
        --color-core-orange-warning-hover: #eb8d00;
        --color-core-red-critical: #f04832;
        --color-core-red-critical-hover: #ee2f16;
    }

`;
export {
  themeLightBlue
};
//# sourceMappingURL=light-blue.style-VY6NMOV6.js.map
